import React from 'react';
import { Heart, ChevronRight, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '@/lib/favorites';
import FavoriteButton from '@/components/FavoriteButton';

function formatDist(m) {
  if (m == null) return '';
  if (m < 1000) return `${m} m`;
  return `${(m / 1000).toFixed(1)} km`;
}

export default function FavoritesCard() {
  const { items, toggle } = useFavorites();
  const navigate = useNavigate();
  if (items.length === 0) return null;
  return (
    <div className="puvio-card p-5" data-testid="favorites-card">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-xs uppercase tracking-wider font-semibold text-[var(--puvio-accent-text)]">Saved spots</p>
          <p className="text-sm text-[var(--puvio-text-2)] mt-0.5">{items.length} place{items.length === 1 ? '' : 's'} pinned</p>
        </div>
        <div className="w-10 h-10 rounded-2xl bg-[#FFE6E6] flex items-center justify-center">
          <Heart className="w-5 h-5 text-[#FF4D4F] fill-[#FF4D4F]" />
        </div>
      </div>
      <ul className="flex flex-col">
        {items.slice(0, 5).map((p, i) => (
          <li key={i} data-testid={`fav-item-${i}`}>
            <a
              href={p.google_maps_uri || `https://www.google.com/maps/dir/?api=1&destination=${p.lat},${p.lon}`}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 py-2 -mx-1 px-1 rounded-xl hover:bg-[var(--puvio-bg-soft)] transition-colors puvio-focus"
            >
              <span className="w-9 h-9 rounded-full bg-[var(--puvio-bg-soft)] flex items-center justify-center shrink-0">
                <MapPin className="w-4 h-4 text-[var(--puvio-accent-text)]" />
              </span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold truncate">{p.name}</span>
                <span className="block text-[11px] text-[var(--puvio-text-2)] truncate">
                  {p._city?.name && <>{p._city.name} · </>}
                  {p.category}{formatDist(p.distance_m) ? ` · ${formatDist(p.distance_m)}` : ''}
                </span>
              </span>
              <FavoriteButton active onClick={() => toggle(p)} size="sm" testid={`fav-remove-${i}`} />
              <ChevronRight className="w-4 h-4 text-black/30 ml-1" />
            </a>
          </li>
        ))}
      </ul>
      {items.length > 5 && (
        <button type="button" onClick={() => navigate('/map')} className="mt-3 puvio-pill puvio-pill-light text-xs puvio-focus" data-testid="favorites-view-all">
          View all on map
        </button>
      )}
    </div>
  );
}
